import {Component, Input} from '@angular/core';
import {environment} from '~env/environment';

@Component({
  selector: 'app-placa',
  templateUrl: './placa.component.html',
  styleUrls: ['./placa.component.scss'],
})
export class PlacaComponent {
  @Input() placa: string = '';
  private imageApi = `${environment.proxy.imageApi}/png`;
  flag = `${this.imageApi}/other/flag/15`;
}
